var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinterest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 75 75",
    style: {
      enableBackground: "new 0 0 75 75"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#f11b26}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.8,67.6c1-0.9,4.9-5,7-13.5l1.6-6.5c1.5,1.5,3.5,2.6,5.7,3.1c8.8,2.2,17.2-7.2,19.4-16.2 c3.1-12.6-3.3-23.7-14-26.3c-12.3-3-26.7,3-30.3,17.4c-1.2,5.1-0.8,12.7,6,16.4c0.7,0.4,1.6,0,1.8-0.8l1-3.9 c0.1-0.5-0.1-0.9-0.4-1.2c-2.4-2.2-3-5.8-2.2-9.2C23.8,17,33.8,13,42.3,15.1c7.4,1.8,11.9,9.4,9.8,17.9 c-1.5,6.1-5.7,12.8-11.8,11.3c-3.6-0.9-4.1-4.5-3.1-8.5l2.2-9.1c0.6-2.4-0.9-4.7-3.2-5.3c-2.4-0.6-6.1,1.1-7.3,6 c-0.7,2.8-0.1,5.1,1,6.6l-4.5,18.3c-2.1,8.4-0.5,13.9,0,15.2",
    className: "st0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.cef448a88bfc67d71ab576588715ffa3.svg";
export { ForwardRef as ReactComponent };